import { Icons } from '@/assets/icons/icons';
import { Tooltip } from '@/components/ui/Tooltip';

import { useCardSaveEdits } from '../cardOpen';

import { meetingText } from './FeedSourceChip';
import { FEED_OPEN_LINK_CLASS } from './feedStyles';

type FeedMeetingLinkProps = {
  meeting: { name: string; startedAt: Date };
  onOpenSource: () => void;
};

// The meeting that made the card, among the open card's sources as "Open in" is: the meetings mark, the meeting and
// the day it started. It opens the meeting
export const FeedMeetingLink = ({
  meeting,
  onOpenSource,
}: FeedMeetingLinkProps) => {
  const saveEdits = useCardSaveEdits();
  const name = meetingText(meeting.name);
  const day = meeting.startedAt.toLocaleDateString([], {
    month: 'short',
    day: 'numeric',
  });

  return (
    <Tooltip label={`Open the ${name}`}>
      <button
        type="button"
        // Capped, so a long meeting name truncates rather than taking a custom-body header's title width
        className={`${FEED_OPEN_LINK_CLASS} max-w-[calc(220*var(--ac-u))]`}
        // Opening the meeting leaves the card, so what the user typed saves first; a refused save keeps them on it
        onClick={async () => {
          if (await saveEdits()) onOpenSource();
        }}
      >
        <Icons.meetings
          aria-hidden="true"
          className="size-[calc(15*var(--ac-u))] shrink-0"
        />
        <span className="truncate">{`${name} · ${day}`}</span>
      </button>
    </Tooltip>
  );
};
